<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="cms-list">
    <data-table :service="CMSService"
                :entity="entity"
                :filters="filters"
                :columns="columns"
                :disable-permission-checks="true"
                ref="table">
      <template v-slot:title="{row}">
        <div class="d-flex align-items-center">
          <base-avatar :name="row.title"
                       :circle="false"
                       size="xl"
                       class="post-image"
                       :src="row.image">
          </base-avatar>
          <div class="ml-3 font-weight-bold">
            <div>
              {{row.title}}
            </div>
            <badge :type="row.type === 'news' ? 'info' : 'success'">{{row.type}}</badge>
          </div>
        </div>
      </template>
      <template v-slot:user="{row}">
        <div class="font-weight-bold">{{row.user.given_name}}</div>
      </template>
      <template v-slot:active="{row}">
        <status-badge :status="row.active ? 'active': 'inactive'"></status-badge>
      </template>
      <template v-slot:segments="{row}">
        <div class="segments__container">
          <div v-for="segment in row.segments"
               :key="segment.id"
               class="d-flex align-items-center">
            <badge type="info">
              {{segment.value}}
            </badge>
            &nbsp;
          </div>
        </div>
      </template>
    </data-table>
  </div>
</template>
<script>
  import Badge from 'src/components/Badge'
  import CMSService from 'src/services/CMSService';
  import entities from 'src/config/entities';

  export default {
    name: 'cms-list',
    components: {
      Badge
    },
    data() {
      return {
        CMSService,
        entity: entities.CMS
      }
    },
    computed: {
      filters() {
        return [
          {
            key: 'with',
            value: 'segments,job_board,user'
          }
        ]
      },
      columns() {
        return [
          {
            prop: "title",
            label: this.$t('cms.form.title'),
            minWidth: "350px",
          },
          {
            prop: "user",
            label: this.$t('cms.form.user'),
            minWidth: "130px",
          },
          {
            prop: "description",
            label: this.$t('cms.form.description'),
            minWidth: "220px",
          },
          {
            prop: "active",
            label: this.$t('cms.form.active'),
            minWidth: "80px",
          },
          {
            prop: "segments",
            label: this.$t('cms.form.segments'),
            minWidth: "150px",
          },
        ]
      }
    }
  }
</script>
<style lang="scss" scoped>
  .post-image {
    min-width: 144px;
  }
  .segments__container {
    overflow-x: auto;
    display: flex;
  }
</style>
